const PremiseUser = {

    // FIELDS
    "premise": "Premise",
    "role": "Role",
    "fname": "First Name",
    "lname": "Last Name",
    "gender": "Gender",
    "username": "Username",
    "password": "Password",
    "confirm_password": "Confirm Password",
    "mobile": "Mobile Number",
    "email": "Email",
    "profile": "Profile Photo",
    "dob": "Date of Birth",
    "joining_date": "Joining Date",
    "salary": "Salary",
    "status": "Status",
    "excel_file": "Excel File",

    // PAGE HEADER
    "premise_user": "Premise User",
    "search": "Search",
    "bulk_upload_resident": "Bulk Upload Resident",
    "sample_file": "Sample File",
    "resident_onboard": "Resident Onboard",

    // DETAILS PAGE
    "units_parking": "Units, Parking & Vehicles",
    "units": "Units",
    "vehicles": "Vehicles",
    "no_units": "No units assigned to this user",
    "no_parking": "No parking assigned",
    "no_vehicles": "No vehicles",

    // TOAST
    "export_success": "Sample file exported successfully",
    "export_fail": "Sample file export failed",

    // TABLE HEADERS
    "table_premise": "PREMISE",
    "table_name": "NAME",
    "table_username": "USERNAME",
    "table_email": "EMAIL",
    "table_mobile": "MOBILE",
    "table_role": "ROLE",
    "table_gender": "GENDER",
    "table_status": "STATUS",
    "table_two_way_auth": "2 WAY AUTH",

    // ERROR MESSAGES
    "error_premise": "Select Premise",
    "error_role": "Select Role",
    "error_fname": "Enter First Name",
    "error_lname": "Enter Last Name",
    "error_gender": "Select Gender",
    "error_username": "Enter Username",
    "error_password": "Enter Password",
    "error_confirm_password": "Enter Confirm Password",
    "error_password_match": "Confirm Password doesn't match",
    "error_mobile": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number (10 digits required)",
    "error_email": "Enter Email",
    "error_invalid_email": "Invalid Email Address",
    "error_file_size": "File size must be less than 5MB",
    "error_file_type": "Only JPG, JPEG, PNG images are allowed",
    "error_dob": "Select Date of Birth",
    "error_joining_date": "Select Joining Date",
    "error_salary": "Enter Salary",
    "error_salary_negative": "Salary cannot be negative",
    "error_status": "Select Status",
    "error_excel_file": "Upload Excel File",
    "error_excel_file_invalid": "Please upload a valid Excel File (.csv)",
    "error_username_unique": "Username must be unique",
    "error_count": "Error Count",
}

export default PremiseUser;